import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  tableHead: {
    color: '#918E8E'
  }
});

export const TableHead = (props: any) => {
  return (
    <View style={styles.tableHead}>
      {props.children}
    </View>
  )
};

export default TableHead;
